import React, { useState, useEffect, useRef, useCallback } from "react";
import moment from "moment-timezone";
import { MultiSelect } from "react-multi-select-component";
import { requestData } from "../services/requests";
import { cpfMask } from "../services/funcoesAuxiliares";
import { toast } from "react-toastify";
import {
  Filter,
  Eraser,
  Search,
  X,
  Calendar,
  User,
  Hash,
  CreditCard,
} from "lucide-react";

const FiltrarDados = ({
  setError,
  getCarteiras,
  activeTab,
  page,
  limit,
  getSearch,
}) => {
  const arrayStatus = [
    { label: "Recepcionada", value: "Recepcionada" },
    { label: "Validada", value: "Validada" },
    { label: "Renovação", value: "Renovacao" },
    { label: "Expirada", value: "Expirada" },
    { label: "Cancelada", value: "Cancelada" },
  ];

  const arrayTags = [
    { label: "Aprovada", value: "APROVADA" },
    { label: "Reprovada", value: "REPROVADA" },
    { label: "Pendente", value: "PENDENTE" },
  ];

  const hoje = moment().format().split("T")[0];
  const mesPassado = moment().subtract(1, "month").format();
  const MesAnterior = mesPassado.split("T")[0];

  const { name, role } = JSON.parse(localStorage.getItem("user"));

  const codUsoRef = useRef(null);
  const nomeAlunoRef = useRef(null);
  const cpfRef = useRef(null);
  const [filterSearch, setFilterSearch] = useState([]);
  const [filterSearchAluno, setFilterSearchAluno] = useState([]);
  const [users, setUsers] = useState([]);
  const [nomeAluno, setNomeAluno] = useState("");
  const [codigoUso, setCodigoUso] = useState("");
  const [gestor, setGestor] = useState([{ label: name, value: name, id: 1 }]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [dataInicial, setDataInicial] = useState(MesAnterior);
  const [dataFinal, setDataFinal] = useState(hoje);
  const [cpf, setCpf] = useState("");
  const [isFilterExpanded, setIsFilterExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showNomeSuggestions, setShowNomeSuggestions] = useState(false);
  const [showCodigoSuggestions, setShowCodigoSuggestions] = useState(false);
  const [vendedores, setVendedores] = useState([]);
  const [selectedVendedor, setSelectedVendedor] = useState([]);
  const [selectedTag, setSelectedTag] = useState([]);

  const formattedCodigoUso = useCallback((value) => {
    const numbers = value.replace(/\D/g, '');

    if (numbers.length <= 4) {
      return numbers;
    } else if (numbers.length <= 7) {
      return `${numbers.slice(0, 4)}-${numbers.slice(4)}`;
    } else {
      return `${numbers.slice(0, 4)}-${numbers.slice(4, 7)}.${numbers.slice(7, 10)}`;
    }
  }, []);
  
  const handleChange = useCallback(
    async (value) => {
      const formattedCodigo = formattedCodigoUso(value);
      setCodigoUso(formattedCodigo);
      if (value.length >= 3) {
        setShowCodigoSuggestions(true);
        const codigosTeste = await getSearch(
          activeTab,
          { codigoUso: formattedCodigo },
          page,
          limit
        );
        setFilterSearch(codigosTeste);
      } else {
        setFilterSearch([]);
        setShowCodigoSuggestions(false);
      }
    },
    [activeTab, getSearch, page, limit, formattedCodigoUso]
  );

  const handleChangeAluno = useCallback(
    async (value) => {
      setNomeAluno(value);
      if (value.length >= 3) {
        setShowNomeSuggestions(true);
        const nomesTeste = await getSearch(
          activeTab,
          { name: value },
          page,
          limit
        );
        setFilterSearchAluno(nomesTeste);
      } else {
        setFilterSearchAluno([]);
        setShowNomeSuggestions(false);
      }
    },
    [activeTab, getSearch, page, limit]
  );

  const handleClickCodigoUso = (value) => {
    setCodigoUso(value.codigoUso);
    setFilterSearch([]);
    setShowCodigoSuggestions(false);
  };

  const handleClickAluno = (value) => {
    setNomeAluno(value.name);
    setFilterSearchAluno([]);
    setShowNomeSuggestions(false);
  };

  const gestores = async () => {
    const endpoint = "/user/all";
    const gestores = await requestData(endpoint);
    setUsers(gestores);
  };

  const getVendedores = async () => {
    try {
      const endpoint = "/vendedores";
      const vendedoresData = await requestData(endpoint);
      setVendedores(vendedoresData);
    } catch (error) {
      toast.warning("Nenhum vendedor cadastrado!");
    }
  };

  const newArrayGestores = users
    .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
    .map((user) => ({ label: user.name, value: user.name, id: user.id }));

  const newArrayVendedores = vendedores
    .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
    .map((vendedor) => ({ label: vendedor.nome, value: vendedor.nome, id: vendedor.id }));

  const filtrar = useCallback(
    async (e) => {
      e.preventDefault();
      setIsLoading(true);

      try {
        const filterParams = {
          name: nomeAluno,
          codigoUso,
          gestores: gestor.map((c) => c.id),
          selectedStatus: selectedStatus.map((e) => e.value),
          dataInicial,
          dataFinal,
          cpf,
          // Filtros específicos para vendedores
          vendedores: selectedVendedor.map((v) => v.id),
          tags: selectedTag.map((t) => t.value),
        };
        await getCarteiras(activeTab, filterParams, page, limit);
      } catch (error) {
        setError(true);
      } finally {
        setIsLoading(false);
      }
    },
    [
      activeTab,
      getCarteiras,
      page,
      limit,
      nomeAluno,
      codigoUso,
      gestor,
      selectedStatus,
      dataInicial,
      dataFinal,
      cpf,
      selectedVendedor,
      selectedTag,
      setError,
    ]
  );

  const limparFiltro = useCallback(
    async (e) => {
      e.preventDefault();
      setIsLoading(true);

      try {
        setNomeAluno("");
        setCodigoUso("");
        setGestor([{ label: name, value: name, id: 1 }]);
        setSelectedStatus([]);
        setDataInicial(MesAnterior);
        setDataFinal(hoje);
        setCpf("");
        setFilterSearch([]);
        setFilterSearchAluno([]);
        setSelectedVendedor([]);
        setSelectedTag([]);
        setError(false);
        await getCarteiras(activeTab, null, 1, 10);
      } catch (error) {
        setError(true);
      } finally {
        setIsLoading(false);
      }
    },
    [activeTab, getCarteiras, name, MesAnterior, hoje, setError]
  );

  const clearField = (field) => {
    switch (field) {
      case "nome":
        setNomeAluno("");
        setFilterSearchAluno([]);
        setShowNomeSuggestions(false);
        break;
      case "codigo":
        setCodigoUso("");
        setFilterSearch([]);
        setShowCodigoSuggestions(false);
        break;
      case "cpf":
        setCpf("");
        break;
      default:
        break;
    }
  };

  const hasActiveFilters = () => {
    return (
      nomeAluno ||
      codigoUso ||
      cpf ||
      selectedStatus.length > 0 ||
      (role === "administrador" && gestor.length > 1) ||
      dataInicial !== MesAnterior ||
      dataFinal !== hoje ||
      selectedVendedor.length > 0 ||
      selectedTag.length > 0
    );
  };

  useEffect(() => {
    if (codigoUso === "") {
      setFilterSearch([]);
      setShowCodigoSuggestions(false);
    }

    if (nomeAluno === "") {
      setFilterSearchAluno([]);
      setShowNomeSuggestions(false);
    }

    if (role === "administrador") {
      gestores();
    }

    if (activeTab === "vendedores") {
      getVendedores();
    }
  }, [codigoUso, nomeAluno, role, activeTab]);

  return (
    <section className="mt-5 mb-5 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg shadow-lg border border-blue-200">
      {/* Header com botão de toggle para mobile */}
      <div className="flex items-center justify-between p-4 border-b border-blue-200">
        <div className="flex items-center gap-2">
          <Filter className="w-5 h-5 text-blue-600" />
          <h3 className="text-lg font-semibold text-gray-800">Filtros</h3>
          {hasActiveFilters() && (
            <span className="bg-blue-600 text-white text-xs px-2 py-1 rounded-full">
              {
                [
                  nomeAluno,
                  codigoUso,
                  cpf,
                  selectedStatus.length,
                  gestor.length > 1 ? 1 : 0,
                  selectedVendedor.length,
                  selectedTag.length,
                ].filter(Boolean).length
              }{" "}
              ativo(s)
            </span>
          )}
        </div>
        <button
          onClick={() => setIsFilterExpanded(!isFilterExpanded)}
          className="lg:hidden p-2 text-blue-600 hover:bg-blue-100 rounded-md transition-colors"
        >
          {isFilterExpanded ? (
            <X className="w-5 h-5" />
          ) : (
            <Search className="w-5 h-5" />
          )}
        </button>
      </div>

      {/* Formulário de filtros */}
      <div
        className={`${
          isFilterExpanded ? "block" : "hidden"
        } lg:block transition-all duration-300`}
      >
        <form onSubmit={filtrar} className="p-4 space-y-4">
          {/* Filtros para tab de gestores */}
          {activeTab === "gestores" && (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                <User className="w-4 h-4 inline mr-1" />
                Nome do Aluno
              </label>
              <div className="relative">
                <input
                  ref={nomeAlunoRef}
                  id="nomeAluno"
                  type="text"
                  value={nomeAluno}
                  onChange={({ target: { value } }) =>
                    handleChangeAluno(value.toUpperCase())
                  }
                  onFocus={() =>
                    nomeAluno.length >= 3 && setShowNomeSuggestions(true)
                  }
                  onBlur={() =>
                    setTimeout(() => setShowNomeSuggestions(false), 200)
                  }
                  placeholder="Digite o nome do aluno..."
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                />
                {nomeAluno && (
                  <button
                    type="button"
                    onClick={() => clearField("nome")}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    <X className="w-4 h-4" />
                  </button>
                )}
              </div>

              {showNomeSuggestions && filterSearchAluno.length > 0 && (
                <div className="absolute z-30 w-full mt-2 bg-white border border-gray-300 rounded-lg shadow-xl max-h-60 overflow-y-auto">
                  <div className="p-2 border-b border-gray-200 bg-gray-50">
                    <span className="text-xs font-medium text-gray-600">
                      {filterSearchAluno.length} resultado(s) encontrado(s)
                    </span>
                  </div>
                  <div className="max-h-48 overflow-y-auto">
                    {filterSearchAluno.map((e) => (
                      <div
                        key={e.id}
                        onClick={() => handleClickAluno(e)}
                        className="p-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors group"
                      >
                        <div className="flex items-center gap-2">
                          <User className="w-4 h-4 text-gray-400 group-hover:text-blue-500" />
                          <span className="text-sm text-gray-800 group-hover:text-blue-700 font-medium">
                            {e.name}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="p-2 border-t border-gray-200 bg-gray-50">
                    <button
                      type="button"
                      onClick={() => setShowNomeSuggestions(false)}
                      className="text-xs text-gray-500 hover:text-gray-700"
                    >
                      Fechar sugestões
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="relative">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                <Hash className="w-4 h-4 inline mr-1" />
                Código de Uso
              </label>
              <div className="relative">
                <input
                  ref={codUsoRef}
                  id="CodUso"
                  type="text"
                  value={codigoUso}
                  onChange={({ target: { value } }) => handleChange(value)}
                  onFocus={() =>
                    codigoUso.length >= 3 && setShowCodigoSuggestions(true)
                  }
                  onBlur={() =>
                    setTimeout(() => setShowCodigoSuggestions(false), 200)
                  }
                  placeholder="Digite o código de uso..."
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                />
                {codigoUso && (
                  <button
                    type="button"
                    onClick={() => clearField("codigo")}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    <X className="w-4 h-4" />
                  </button>
                )}
              </div>

              {showCodigoSuggestions && filterSearch.length > 0 && (
                <div className="absolute z-30 w-full mt-2 bg-white border border-gray-300 rounded-lg shadow-xl max-h-60 overflow-y-auto">
                  <div className="p-2 border-b border-gray-200 bg-gray-50">
                    <span className="text-xs font-medium text-gray-600">
                      {filterSearch.length} resultado(s) encontrado(s)
                    </span>
                  </div>
                  <div className="max-h-48 overflow-y-auto">
                    {filterSearch.map((e) => (
                      <div
                        key={e.id}
                        onClick={() => handleClickCodigoUso(e)}
                        className="p-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors group"
                      >
                        <div className="flex items-center gap-2">
                          <Hash className="w-4 h-4 text-gray-400 group-hover:text-blue-500" />
                          <span className="text-sm text-gray-800 group-hover:text-blue-700 font-mono">
                            {e.codigoUso}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="p-2 border-t border-gray-200 bg-gray-50">
                    <button
                      type="button"
                      onClick={() => setShowCodigoSuggestions(false)}
                      className="text-xs text-gray-500 hover:text-gray-700"
                    >
                      Fechar sugestões
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Segunda linha - CPF e Status */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                <CreditCard className="w-4 h-4 inline mr-1" />
                CPF
              </label>
              <div className="relative">
                <input
                  ref={cpfRef}
                  id="cpf"
                  type="text"
                  value={cpf}
                  onChange={({ target: { value } }) => setCpf(cpfMask(value))}
                  placeholder="Digite o CPF..."
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                />
                {cpf && (
                  <button
                    type="button"
                    onClick={() => clearField("cpf")}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    <X className="w-4 h-4" />
                  </button>
                )}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Status
              </label>
              <MultiSelect
                options={arrayStatus}
                value={selectedStatus}
                onChange={setSelectedStatus}
                labelledBy="Status"
                className="w-full"
                overrideStrings={{
                  allItemsAreSelected: "Todos os status selecionados",
                  clearSearch: "Limpar busca",
                  clearSelected: "Limpar seleção",
                  noOptions: "Nenhum status encontrado",
                  search: "Buscar status...",
                  selectAll: "Selecionar todos",
                  selectSomeItems: "Selecionar status...",
                }}
              />
            </div>
          </div>

          {/* Terceira linha - Datas e Gestores */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                <Calendar className="w-4 h-4 inline mr-1" />
                Período
              </label>
              <div className="grid grid-cols-2 gap-2">
                <input
                  id="dataInicial"
                  type="date"
                  value={dataInicial}
                  onChange={({ target: { value } }) => setDataInicial(value)}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                />
                <input
                  id="dataFinal"
                  type="date"
                  value={dataFinal}
                  onChange={({ target: { value } }) => setDataFinal(value)}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                />
              </div>
            </div>

            {role === "administrador" && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <User className="w-4 h-4 inline mr-1" />
                  Gestores
                </label>
                <MultiSelect
                  options={newArrayGestores}
                  value={gestor}
                  onChange={setGestor}
                  labelledBy="Gestores"
                  className="w-full"
                  overrideStrings={{
                    allItemsAreSelected: "Todos os gestores selecionados",
                    clearSearch: "Limpar busca",
                    clearSelected: "Limpar seleção",
                    noOptions: "Nenhum gestor encontrado",
                    search: "Buscar gestores...",
                    selectAll: "Selecionar todos",
                    selectSomeItems: "Selecionar gestores...",
                  }}
                />
              </div>
            )}
          </div>
            </>
          )}

          {/* Filtros para tab de vendedores */}
          {activeTab === "vendedores" && (
            <>
              {/* Primeira linha - Nome e Vendedores */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="relative">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    <User className="w-4 h-4 inline mr-1" />
                    Nome do Aluno
                  </label>
                  <div className="relative">
                    <input
                      ref={nomeAlunoRef}
                      id="nomeAluno"
                      type="text"
                      value={nomeAluno}
                      onChange={({ target: { value } }) =>
                        handleChangeAluno(value.toUpperCase())
                      }
                      onFocus={() =>
                        nomeAluno.length >= 3 && setShowNomeSuggestions(true)
                      }
                      onBlur={() =>
                        setTimeout(() => setShowNomeSuggestions(false), 200)
                      }
                      placeholder="Digite o nome do aluno..."
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    />
                    {nomeAluno && (
                      <button
                        type="button"
                        onClick={() => clearField("nome")}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    )}
                  </div>

                  {showNomeSuggestions && filterSearchAluno.length > 0 && (
                    <div className="absolute z-30 w-full mt-2 bg-white border border-gray-300 rounded-lg shadow-xl max-h-60 overflow-y-auto">
                      <div className="p-2 border-b border-gray-200 bg-gray-50">
                        <span className="text-xs font-medium text-gray-600">
                          {filterSearchAluno.length} resultado(s) encontrado(s)
                        </span>
                      </div>
                      <div className="max-h-48 overflow-y-auto">
                        {filterSearchAluno.map((e) => (
                          <div
                            key={e.id}
                            onClick={() => handleClickAluno(e)}
                            className="p-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors group"
                          >
                            <div className="flex items-center gap-2">
                              <User className="w-4 h-4 text-gray-400 group-hover:text-blue-500" />
                              <span className="text-sm text-gray-800 group-hover:text-blue-700 font-medium">
                                {e.name}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="p-2 border-t border-gray-200 bg-gray-50">
                        <button
                          type="button"
                          onClick={() => setShowNomeSuggestions(false)}
                          className="text-xs text-gray-500 hover:text-gray-700"
                        >
                          Fechar sugestões
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    <User className="w-4 h-4 inline mr-1" />
                    Colaboradores
                  </label>
                  <MultiSelect
                    options={newArrayVendedores}
                    value={selectedVendedor}
                    onChange={setSelectedVendedor}
                    labelledBy="Vendedores"
                    className="w-full"
                    overrideStrings={{
                      allItemsAreSelected: "Todos os vendedores selecionados",
                      clearSearch: "Limpar busca",
                      clearSelected: "Limpar seleção",
                      noOptions: "Nenhum colaborador encontrado",
                      search: "Buscar colaboradores...",
                      selectAll: "Selecionar todos",
                      selectSomeItems: "Selecionar colaboradores...",
                    }}
                  />
                </div>
              </div>

              {/* Segunda linha - Tags e Período */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    <Hash className="w-4 h-4 inline mr-1" />
                    Tags
                  </label>
                  <MultiSelect
                    options={arrayTags}
                    value={selectedTag}
                    onChange={setSelectedTag}
                    labelledBy="Tags"
                    className="w-full"
                    overrideStrings={{
                      allItemsAreSelected: "Todas as tags selecionadas",
                      clearSearch: "Limpar busca",
                      clearSelected: "Limpar seleção",
                      noOptions: "Nenhuma tag encontrada",
                      search: "Buscar tags...",
                      selectAll: "Selecionar todas",
                      selectSomeItems: "Selecionar tags...",
                    }}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    <Calendar className="w-4 h-4 inline mr-1" />
                    Período
                  </label>
                  <div className="grid grid-cols-2 gap-2">
                    <input
                      id="dataInicial"
                      type="date"
                      value={dataInicial}
                      onChange={({ target: { value } }) => setDataInicial(value)}
                      className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    />
                    <input
                      id="dataFinal"
                      type="date"
                      value={dataFinal}
                      onChange={({ target: { value } }) => setDataFinal(value)}
                      className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Botões de ação */}
          <div className="flex flex-col sm:flex-row gap-3 pt-4 border-t border-gray-200">
            <button
              type="button"
              onClick={limparFiltro}
              disabled={isLoading}
              className="flex-1 sm:flex-none sm:px-6 py-3 bg-yellow-500 hover:bg-yellow-600 disabled:bg-yellow-300 text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              <Eraser className="w-4 h-4" />
              {isLoading ? "Limpando..." : "Limpar Filtros"}
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 sm:flex-none sm:px-6 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              <Filter className="w-4 h-4" />
              {isLoading ? "Filtrando..." : "Aplicar Filtros"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default FiltrarDados;
